<template>
  <span v-html="termo.conteudo"></span>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import sweetAlert from "./controller/sweetAlert";

export default {
  mixins: [sweetAlert],

  components: { Loading },

  props: ["termo"],

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>
